<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <el-pagination
          :disabled="isLoading"
          :current-page="listQuery.page"
          :page-sizes="listQuery.sizes"
          :page-size="listQuery.size"
          :total="listQuery.total"
          background
          layout="total, sizes, pager, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
        <div class="button-container">
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreateButtonClick"
          >{{ $t('button.create') }}</el-button>
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
    >
      <!-- Data Columns -->
      <el-table-column
        v-for="{ type, ...column } in columnList"
        :key="type"
        :prop="type"
        :label="column.title || $t(`table.${type}`)"
        v-bind="column.custom"
      >
        <template #default="{ row, $index }">
          <div :class="{ disabled: isProcessing(row) }">
            {{ row[type] }}
          </div>
        </template>
      </el-table-column>
      <!-- Data Columns -->

      <!-- Actions -->
      <el-table-column
        :label="$t('table.action')"
        fixed="right"
        align="center"
        width="120"
      >
        <template #default="{ row }">
          <div
            :class="['button-group', { disabled: isProcessing(row) }]"
          >
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="handleEditButtonClick(row)"
            />
            <el-button
              size="mini"
              round
              @click="handleCopyButtonClick(row)"
            >{{ $t('button.copy') }}</el-button>
          </div>
        </template>
      </el-table-column>
      <!-- Actions -->
    </el-table>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import ShopTheLookService from '../../api/shop-the-look'

export default {
  name: 'ShopTheLookList',
  mixins: [useTablePaging],
  data() {
    // configs for the columns of the list
    const columnList = [
      { type: 'id', custom: { width: '50' } },
      { type: 'title', custom: { 'min-width': '120' } },
      { type: 'country', custom: { width: '80' } },
      { type: 'created_at', custom: { width: '160' }, title: this.$t('table.createdTime') },
      { type: 'status', custom: { width: '60' }, title: this.$t('table.enable') },
    ]
    return {
      isLoading: false,
      columnList,
      processingIds: new Set(),
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await ShopTheLookService.getList(this.listQuery.page, this.listQuery.size)
        const { data: newList, pagination } = response
        this.list = newList.map(item => ({
          ...item,
          status: item.status === 1 ? this.$t('common.yes') : this.$t('common.no'),
        }))
        this.listQuery.total = parseInt(pagination.total_items, 0)
        this.isLoading = false
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false
      }
    },
    async copyItem(id) {
      this.processingIds.add(id)
      this.processingIds = new Set(this.processingIds)
      try {
        await ShopTheLookService.duplicate(id)
      } catch (error) {
        console.error(error)
      } finally {
        this.processingIds.delete(id)
        this.processingIds = new Set(this.processingIds)
        this.getList()
      }
    },
    handleEditButtonClick({ id }) {
      this.$router.push({ path: `/shop-the-look/edit/${id}` })
    },
    handleCreateButtonClick() {
      this.$router.push({ path: '/shop-the-look/create' })
    },
    handleCopyButtonClick({ id }) {
      this.$confirm(this.$t('message.confirmToCopy'), this.$t('common.warning'), {
        confirmButtonText: this.$t('button.ok'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        // Update server
        this.copyItem(id)
      })
    },
    isProcessing({ id }) {
      return this.processingIds.has(id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>
